import $ from 'jquery';

class SiteSearch {
  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.searchContainer = $(".allSearch__container");
    this.resultsDiv = $(".allSearch__results");
    this.showButton = $(".allSearch__link");
    this.loadMoreButton = $(".allSearch__load a");
    this.events();
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
  }

  events() {
    this.showButton.on("click", this.fetchLogic.bind(this));
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
  }

  fetchLogic(e) {

    if ($(this)) {
      clearTimeout(this?.typingTimer);

      let target = e.target;
      target = target?.getAttribute('href');
      target = target?.substring(1, target.length);

      $('.allSearch__link, .allSearch__tabsContent .tab-pane').removeClass('active show');
      $(e.target).addClass('active show');
      $(`#${target}`).addClass('active show');


      if (this.showButton) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults(target), 750);
        this.loadMoreButton.attr("data-url", `term=${target}&page=2&number=20`);
      } else {
        this.resultsDiv.html('');
        this.isSpinnerVisible = false;
      }
    }
  }

  getResults(personaValue) {
    let i = 0;
    let page = 1;
    let per_page = 30;
    let searchTerm = $(".allSearch__container").attr("data-search");
    if (personaValue === 'all' || personaValue == 'undefined' || personaValue == null) {
      personaValue = 'pagesearch';
    }

    //$.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/'+personaValue+'?term=' + searchTerm + '&page=1&number=20', (results) => {
    $.when($.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/'+personaValue+'?term=' + searchTerm + '&page=1&number=20')).then((results) => {
      let currentPage = results.current_page;
      if (personaValue === 'article') {
        this.resultsDiv.html(`
            ${results.marsArticles.length ? '<div class="allSearch__row">' : '<p>No result matches your search.</p>'}
              ${results.marsArticles.map(item => `<a href="${item.permalink}" title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.marsArticles.length ? '</div>' : ''}
          </div> 
      `);
      }

      else if (personaValue === 'venues') {
        this.resultsDiv.html(`
            ${results.venueInfo.length ? '<div class="allSearch__row">' : '<p>No venues matches your search.</p>'}
              ${results.venueInfo.map(item => `<a href="${item.permalink}" title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.venueInfo.length ? '</div>' : ''}
          </div> 
      `);
      }

      else if (personaValue === 'events') {
        this.resultsDiv.html(`
            ${results.eventInfo.length ? '<div class="row allEvents__row eventSection__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event ${item.add_event_cta === true ? "event__cta-wrapper":""}">
                <div class="eventSection__event">
                
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}"}>

                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

          `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.start_date}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
             
                </a>`}
                  
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
        `);
      }

      else {
        this.resultsDiv.html(`
            ${results.marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches your search.</p>'}
              ${results.marsResults.map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.marsResults.length ? '</div>' : ''}
          </div>
        `);

      }

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `${personaValue}?term=${searchTerm}&page=2&number=20`);
      `${(results.max_pages == currentPage || results.max_pages == 0) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
      console.log('getResults error:', error);
    });

  }


  LoadActiveResults() {

    if ($(".allSearch__container").length) {
      let searchTerm = $(".allSearch__container").attr("data-search");
      let page = 1;
      let per_page = 30;
      if (!this.isSpinnerVisible) {
        $(".allSearch__results").html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
        this.isSpinnerVisible = true;
      }

      if ($(".allSearch__results").length) {
        $.when($.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/pagesearch?term=' + searchTerm + '&page=1&number=-1'),
          $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/article?term=' + searchTerm + '&page=1&number=-1'),
          $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/venues?term=' + searchTerm + '&page=1&number=-1'),
          $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/events?term=' + searchTerm + '&page=1&number=-1')).then((results, articles, venues, events) => {

          let currentPage = results[0].current_page;
          let allTotal = results[0].total_found;
          let articlesTotal = articles[0].total_found;
          let venuesTotal = venues[0].total_found;
          let eventsTotal = events[0].total_found;
          let articleTotal = results[0].marsArticles.length;

          $(".allSearch__link span.all, span.countTotal").html(`${allTotal}`);
          $(".allSearch__link span.article").html(`${articleTotal}`);

          this.resultsDiv.html(`
            ${results[0].marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches your search.</p>'}
              ${results[0].marsResults.slice(0, 20).map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results[0].marsResults.length ? '</div>' : ''}
          </div>
          `);

          $(".allSearch__link span.article").html(`${articlesTotal}`);
          $(".allSearch__link span.venues").html(`${venuesTotal}`);
          $(".allSearch__link span.events").html(`${eventsTotal}`);
          //(total === undefined || total === null) ? total = 0 : '';
          // $(".allSearch__link span.careers").html(`${careerTotal}`);

          this.isSpinnerVisible = false;
          this.loadMoreButton.attr("data-url", `pagesearch?term=${searchTerm}&page=2&number=20`);
          `${(results[0].max_pages == currentPage || results[0].marsResults.length == 0 ) ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
        });
      }
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let i = 0;
    let currentType = this.loadInfo.split('?');
    let searchTerm = currentType[1].split('&');
    searchTerm = searchTerm[0].split('=');

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
        <div class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/' + this.loadInfo, (results) => {
      let currentPage = results.current_page;

      if (currentType[0] === 'article') {
        this.resultsDiv.append(`
            ${results.marsArticles.length ? '<div class="allSearch__row">' : '<p>No result matches your search.</p>'}
            ${results.marsArticles.map(item => `<a href="${item.permalink}" title="${item.title}" class="allSearch__card">
              <h4>${item.title}</h4>
              </a>`).join('')}
            ${results.marsArticles.length ? '</div>' : ''}
          </div>
      `);
      }

      else if (currentType[0] === 'events') {

        this.resultsDiv.append(`
            ${results.eventInfo.length ? '<div class="row allEvents__row eventSection__boxes">' : '<p>No Event information matches the search term.</p>'}
              ${results.eventInfo.map(item => `<div class="col-12 col-md-4 col-sm-4 allEvents__event ${item.add_event_cta === true ? "event__cta-wrapper":""}">
                <div class="eventSection__event">
                
                  ${item.add_event_cta === true ? `
                  <a href="${item.event_cta_link}"}>

                    <div class="eventSection__event-cta">
                      ${item.event_cta_content}
                      
                      <i class="event__arrow"><svg xmlns="http://www.w3.org/2000/svg" width="45" height="10" viewBox="0 0 45 10">
                      <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1 5h42M40 1l4 4-4 4"/></g></svg></i>
                    </div>
                  </a>` :

                `<a href="${item.external_link ? item.external_link : item.permalink}" ${item.external_link ? `target="_blank"` : ``}>
                  <div class="eventSection__event-featuredImg" style="background:url(${item.event_image}) no-repeat;"></div>
                  <div class="eventSection__event-contentWrapper">
                      <p class="eventSection__event-sponsor">${item.sponsor}</p>
                      <p class="bold">${item.title}</p>
                      <ul>
                          <li class="marsCal__icon"><span>${item.start_date}</span></li>
                          ${item.start_time ? `<li class="marsClock__icon"><span>${item.start_time} ${item.end_time ? ` - ${item.end_time}` : ``}</span></li>` : ''}
                          <li class="marsPin__icon"><span>${item.location}</span></li>
                      </ul>
                  </div>
                </a>`}
            </div></div>`).join('')}
            ${results.eventInfo.length ? '</div>' : ''}
        `);
      }

      else {
        this.resultsDiv.append(`
            ${results.marsResults.length ? '<div class="allSearch__row">' : '<p>No result matches your search.</p>'}
              ${results.marsResults.map(item => `<a href="${(item.featured_item === true || item.external_page === true ) ? (item.featured_item_link ? item.featured_item_link : item.external_link) : item.permalink}" ${item.external_page === true ? 'target="_blank"' : ''} title="${item.title}" class="allSearch__card">
                <h4>${item.title}</h4>
                </a>`).join('')}
            ${results.marsResults.length ? '</div>' : ''}
          </div>
        `);
      }

      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      this.loadMoreButton.attr("data-url", `${currentType[0]}?term=${searchTerm[1]}&page=${parseInt(currentPage) + 1}&number=20`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

}

export default SiteSearch;